// Small presentational wrapper that applies the repeated dark-input
// styles used across the RSVP flows. Keeps the flow JSX readable without
// introducing a CSS module system. Props passthrough via ...rest so
// callers can still attach refs, names, autoComplete, etc.

const BASE_STYLE = {
  background: "rgba(0,0,0,0.04)",
  color: "var(--black)",
  borderColor: "rgba(0,0,0,0.25)",
  marginBottom: 0,
  // Webflow's base .text-field clears horizontal padding, which looks
  // cramped once the input carries a tinted background. Restore a
  // comfortable gutter so the text doesn't hug the edge.
  paddingLeft: 14,
  paddingRight: 14,
};

const Field = ({
  as = "input",
  style,
  className = "text-field w-input",
  ...rest
}) => {
  const merged = { ...BASE_STYLE, ...style };
  if (as === "textarea") {
    return <textarea className={className} style={merged} {...rest} />;
  }
  return <input className={className} style={merged} {...rest} />;
};

export default Field;
